"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.frCompanyNumberChecker = void 0;
var _utils = require("./utils");
var SIRET_REGEX = /^\d{14}$/;
var frCompanyNumberChecker = exports.frCompanyNumberChecker = function frCompanyNumberChecker(companyNumber) {
  if (!SIRET_REGEX.test(companyNumber)) {
    return false;
  }
  return (0, _utils.luhnCheck)(companyNumber);
};